const PROD_DECISION_LOG_BUCKET = "jig-prod-decision-logs";

const S3_CONSOLE_REGION = "eu-west-2";

export const decisionLogFolderUrl = (providerId: string, encounterId: string) =>
  `https://${S3_CONSOLE_REGION}.console.aws.amazon.com/s3/buckets/${import.meta.env.VITE_DECISION_LOG_BUCKET ?? PROD_DECISION_LOG_BUCKET}` +
  `?region=${S3_CONSOLE_REGION}&prefix=${encodeURIComponent(`${providerId}/${encounterId}/`)}`;
